// extracted by mini-css-extract-plugin
export default {"container":"SigneeCard_container__nlxpM","nameWrapper":"SigneeCard_nameWrapper__vPyf+","drag":"SigneeCard_drag__Nk2fs"};